import $ from 'jquery';

import responsiveService from '../../Services/responsive';
import widgetFactory from '../widgetFactory';

const widgetName = 'popin',
  className = 'js-' + widgetName;

const widget = widgetFactory(widgetName, {
  options: {},

  _create: function () {
    this._super(className);
    this._addEvents();

    this.elements.$title = this.getWidgetElement('title');
    this.elements.$content = this.getWidgetElement('content');
    this.elements.$actions = this.getWidgetElement('actions');
    this.elements.$icon = this.getWidgetElement('icon');

    this.element.attr('tabindex', -1);

    this.resize();
  },

  _addEvents: function () {
    var self = this;
    responsiveService.registerOnResizeCallback(function () {
      self.element.height('auto');
      self.elements.$content.height('auto');

      // wait for fancy box to redraw
      setTimeout(function () {
        self.resize();
      }, 500);
    });

    this._addEscEventOnFormElement();
  },

  _addEscEventOnFormElement: function () {
    var newEvent = $.Event('keydown');
    newEvent.which = 27;

    $('*', this.element)
      .filter(function (n, elem) {
        return elem.type;
      })
      .on('keydown', function (e) {
        if (e.which === 27) {
          $(document).trigger(newEvent);
        }
      });
  },

  focus: function () {
    this.element.focus();
  },

  resize: function () {
    // TODO: Remove that quick fix, once we're not using old jquery anymore...
    if ($.fn.jquery === '1.7.2') {
      return;
    }

    let $parent = this.element.parent(),
      targetHeight = $parent.height() - parseInt($parent.css('paddingTop'), 10) * 2,
      titleHeight = this.elements.$title.outerHeight(true),
      iconHeight = this.elements.$icon.outerHeight(true),
      actionHeight = this.elements.$actions.outerHeight(true),
      wholeContentHeight = titleHeight + iconHeight + actionHeight,
      availableHeight;

    if (this.elements.$content.outerHeight(true) + wholeContentHeight > targetHeight) {
      this.element.outerHeight(targetHeight);
      availableHeight = this.element.height();

      this.elements.$content
        .outerHeight(availableHeight - wholeContentHeight)
        .css({ 'overflow-y': 'scroll', 'overflow-x': 'hidden', 'padding-right': '16px' });
    }
  },
});

export default widget;
